import GallerySlider from '@components/components/Slider/GallerySlider/GallerySlider';
import PropTypes from 'prop-types';
import React from 'react';

const CmsGallery = ({ images }) => <GallerySlider images={images} />;

CmsGallery.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      alt: PropTypes.string.isRequired,
      caption: PropTypes.string,
      onClick: PropTypes.func,
      srcSet: PropTypes.string,
      src: PropTypes.string.isRequired,
      description: PropTypes.string,
    }),
  ).isRequired,
};

export default CmsGallery;
